import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';
import {PipetteImage, AddButton, MinusButton} from '../MicroPipetteImages';
import {MICROPIPETTE_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import {VOLUME_UPDATE_INTERVAL} from '../MicroPipette.constants';

const {P2, P20, P200, P1000} = MICROPIPETTE_TYPE;

export function SectionRight(props) {
  const [top, mid, bottom] = splitVolumeValue(props.volume, props.type);
  const [increment, setIncrement] = useState(false);
  const [decrement, setDecrement] = useState(false);
  const timeoutRef = useRef();

  useEffect(() => {
    if(increment)
      incrementVolume(VOLUME_UPDATE_INTERVAL);
    else if(decrement)
      decrementVolume(VOLUME_UPDATE_INTERVAL);
    else
      clearTimeoutRef();
  }, [increment, decrement])

  function incrementVolume(delay){
    props.incrementVolume();
    delay = (delay < 50)? 50 : delay * 0.9;
    timeoutRef.current = setTimeout(()=>{incrementVolume(delay)}, delay );
  }

  function decrementVolume(delay){
    props.decrementVolume();
    delay =(delay < 50)? 50 : delay * 0.9;
    timeoutRef.current = setTimeout(()=>{decrementVolume(delay)}, delay );
  }

  function clearTimeoutRef(){
    clearTimeout(timeoutRef.current)
  }

  return (
    <div className={cname.sectionRight}>
      <PipetteImage className={cname.pipette} type={props.type} />
      <AddButton
        className={cname.add}
        onMouseDown={()=>{setIncrement(true)}}
        onMouseUp={()=>{setIncrement(false)}}
      />
      <MinusButton
        className={cname.minus}
        onMouseDown={()=>{setDecrement(true)}}
        onMouseUp={()=>{setDecrement(false)}}
      />
      <div className={cname[props.type]}>
        <p className={cname.top}>{top}</p>
        <p className={cname.mid}>{mid}</p>
        <p className={cname.bottom}>{bottom}</p>
      </div>
    </div>
  );
}

SectionRight.propTypes = {
  /**
   * Current Volume value
   */
  volume: PropTypes.number,
  /**
   * Type of Micropipette [ P2, P20, P200, P1000]
   */
  type: PipetteImage.propTypes.type,
  /**
   * Function to toggle State of increment
   */
  toggleIncrement: PropTypes.func,
  /**
   * Function to toggle State of decrement
   */
  toggleDecrement: PropTypes.func,
};

SectionRight.defualtProps = {};

function splitVolumeValue(volume, type) {
  switch (type) {
    case P1000: {
      return [
        parseInt((volume / 1000) % 10),
        parseInt((volume / 100) % 10),
        parseInt((volume / 10) % 10),
      ];
    }
    case P200: {
      return [
        parseInt((volume / 100) % 10),
        parseInt((volume / 10) % 10),
        parseInt((volume / 1) % 10),
      ];
    }
    case P20:
      return [
        parseInt((volume / 10) % 10),
        parseInt((volume / 1) % 10),
        parseInt(Math.ceil(volume / 0.1) % 10),
      ];
    case P2:
      return [
        parseInt((volume / 1) % 10),
        parseInt((volume / 0.1) % 10),
        parseInt(Math.ceil(volume / 0.01) % 10),
        // (parseFloat(volume.toFixed(2)) / 0.01) % 10,
      ];
    default:
      return [0, 0, 0];
  }
}
